import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
const classNames = require('classnames');
import handleSubtext from '../../../utils/subTextFilter'

import { downArrowSVG, markerSVG } from '../../../../assets/svgIcons';

import { setSelectedTab } from '../../../reducers/filtersSlice';

const Tab = ({ name, tab }) => {
  const { collection: filtersCollection, selectedTab } = useSelector((state) => state.filters);
  const isSelected = tab === selectedTab
  const dispatch = useDispatch();

  const stateColors = isSelected ? ['#5076F6', 'white'].reverse() : ['#5076F6', 'white'];

  let classes = classNames(
    'vesta-dropdown-filter typo-bold-content',
    { 'vesta-bg-blue-100 vesta-white': isSelected },
    { 'vesta-bg-white vesta-indigo-100': !isSelected }
  );

  return (
    <div className={classes} onClick={() => dispatch(setSelectedTab(isSelected ? null : tab))}>
      {tab !== 'location' &&
        <div className='vesta-flex-row-center vesta-gap-10'>
          <div className={`vesta-flex-col-start ${isSelected ? 'vesta-white' : 'vesta-indigo-100'}`}>
            {name}
            <div className={`typo-caption vesta-text-ellipsis ${isSelected ? 'vesta-white' : 'vesta-indigo-50'}`}>
              {handleSubtext(filtersCollection, tab)}
            </div>
          </div>

          <div className={`${isSelected ? 'vesta-rotate-180' : ''}`}>
            {downArrowSVG(...stateColors)}
          </div>
        </div>
      }

      {tab === 'location' &&
        <div className='vesta-flex-col-start vesta-gap-15'>
          <div className='vesta-flex-row-center vesta-gap-10'>
            {markerSVG(...stateColors)}

            <div className='vesta-flex-col-start'>
              {name}
              <div className={`typo-caption vesta-text-ellipsis ${isSelected ? 'vesta-white' : 'vesta-indigo-50'}`}>{filtersCollection.zones.length > 0 ? filtersCollection.zones.map(zone => zone.displayedName).join(', ') : 'Toute la France'}</div>
            </div>

            <div className={`${isSelected ? 'vesta-rotate-180' : ''}`}>
              {downArrowSVG(...stateColors)}
            </div>
          </div>
        </div>
      }
    </div>
  );
}

Tab.propTypes = {
  name: PropTypes.string.isRequired,
  tab: PropTypes.string.isRequired
}

export default Tab;
